export const YMAPS_DEBUG =
  typeof document !== 'undefined' && document.cookie.indexOf('piastrella=mettereapunto') !== -1;

export function onYmapsDebug(cb: () => void) {
  if (YMAPS_DEBUG) {
    cb();
  }
}
